import React, { useState } from "react";
import { cn } from "../../lib/utils";

export function DropdownMenu({ children, trigger, align = "end", placement = "bottom" }) {
  const [open, setOpen] = useState(false);

  const isTop = placement === "top";

  return (
    <div className="relative inline-block text-left">
      <div onClick={() => setOpen(!open)}>{trigger}</div>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div
            className={cn(
              "absolute z-40 w-56 rounded-md border border-slate-200 bg-white shadow-lg dark:border-slate-700 dark:bg-slate-900",
              isTop ? "bottom-full mb-2" : "mt-2",
              align === "end" ? "right-0" : "left-0"
            )}
          >
            <div className="py-1">
              {React.Children.map(children, (child) =>
                React.cloneElement(child, { onClose: () => setOpen(false) })
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export function DropdownMenuItem({ children, onClick, onClose, className }) {
  return (
    <button
      type="button"
      onClick={() => {
        onClick?.();
        onClose?.();
      }}
      className={cn(
        "block w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800",
        className
      )}
    >
      {children}
    </button>
  );
}

export function DropdownMenuSeparator() {
  return <div className="my-1 h-px bg-slate-200 dark:bg-slate-700" />;
}
